<template>
  <div>
    <Input v-model="typeAttr.value" v-if="typeAttr.attr_input_type =='input'"></Input>
    <Select v-model="typeAttr.value" v-else-if="typeAttr.attr_input_type =='select'">
      <Option :value="m" :label="m" v-for="(m,n) in optionsList" :key="n"></Option>
    </Select>
    <Input
      v-model="typeAttr.value"
      type="textarea"
      v-else-if="typeAttr.attr_input_type =='textarea'"
    ></Input>
    <CheckboxGroup
      v-model="typeAttr.value"
      class="m-t-5"
      v-else-if="typeAttr.attr_input_type =='checkbox'"
    >
      <Checkbox :label="m" v-for="(m,n) in optionsList" :key="n"></Checkbox>
    </CheckboxGroup>
    <RadioGroup
      v-model="typeAttr.value"
      class="m-t-5"
      v-else-if="typeAttr.attr_input_type =='radio'"
    >
      <Radio :label="m" v-for="(m,n) in optionsList" :key="n"></Radio>
    </RadioGroup>
  </div>
</template>
<script>
export default {
  //自定义参数的控件
  data() {
    return {
      optionsList: []
    };
  },
  watch: {
    typeAttr: {
      handler: function(val, old) {
        if (val.attr_options) {
          this.optionsList = val.attr_options.split("\n");
        }
      },
      deep: true,
      immediate: true
    }
  },
  props: ["typeAttr", "value"]
};
</script>